import { render } from "./HeaderMenu.vue?vue&type=template&id=2c4f2490&scoped=true&ts=true"
import script from "./HeaderMenu.vue?vue&type=script&lang=ts"
export * from "./HeaderMenu.vue?vue&type=script&lang=ts"

import "./HeaderMenu.vue?vue&type=style&index=0&id=2c4f2490&scoped=true&lang=scss"

import exportComponent from "/builds/Moodbuster2.0/server/web-server/repos/patient_portal_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c4f2490"]])

export default __exports__